// src/components/AuthProvider.tsx
import React, { useEffect } from "react";
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import { useAuthStore } from "@state/auth";
import { apiClient } from "@api/index";

const AuthContextSetter = ({ children }: { children: React.ReactNode }) => {
  const { isLoading, user: authData, isAuthenticated, loginWithRedirect } = useAuth0();
  const { setUser, setUserRoles, user } = useAuthStore();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect();
    }

    if (!user.clientID && isAuthenticated && authData && authData.email && authData.name && authData["http://invintus_user_metadata"].clientID && authData.picture) {

      const clientID = authData["http://invintus_user_metadata"].clientID;
      const userID = authData["http://invintus_user_metadata"].loginID;

      setUser({
        clientID,
        userID,
        name: authData.name,
        email: authData.email,
        profilePicture: authData.picture,
        roles: [],
      });

      // Fetch security roles
      const fetchSecurityRoles = async () => {
        try {
          const response = await fetch("https://crud.v3.invintusmedia.com/SecurityRoles/getSecurityRoles", {
            method: "POST",
            headers: {
              authorization: "console",
              "wsc-api-key": "WTw0fEUjXau3J5e79L6iycALE2456sRef9i0vw5kU",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ clientID }),
          });

          if (response.ok) {
            const data = await response.json();
            if (data.data && data.data.roles) {
              // Filter roles where the user is assigned
              const userRoles = data.data.roles.filter((role: any) => {
                if (role.assignedUsers && Array.isArray(role.assignedUsers)) {
                  return role.assignedUsers.some((assignedUser: any) => {
                    return String(assignedUser.userId) === String(userID);
                  });
                }
                return false;
              });

              setUserRoles(userRoles);
            }
          }
        } catch (error) {
          console.error("Failed to fetch security roles:", error);
        }
      };

      fetchSecurityRoles();
    }
  }, [isLoading, isAuthenticated, authData, setUser, setUserRoles, user, loginWithRedirect]);

  if (isLoading) {
    return null;
  }

  if (isAuthenticated && user.clientID !== "") {
    return <>{children}</>;
  }

  return null;
};

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_ISSUER_BASE_URL!}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID!}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
    >
      <AuthContextSetter>{children}</AuthContextSetter>
    </Auth0Provider>
  );
};

export default AuthProvider;
